<template>
  <v-tooltip location="bottom">
    <template #activator="{ props: onTooltip }">
      <v-menu
        v-model="showMenu"
        location="bottom"
        transition="slide-y-transition"
        :close-on-content-click="false"
      >
        <template #activator="{ props: onMenu }">
          <v-btn
            id="menu-help-button"
            icon
            variant="text"
            color="white"
            class="rounded"
            v-bind="{ ...onMenu, ...onTooltip }"
          >
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-btn>
        </template>
        <v-card flat class="text-body-2 pa-0 ma-0">
          <v-list class="pa-0">
            <v-list-item
              v-for="item in items"
              :key="item.title"
              class="list"
              :prepend-icon="item.icon"
              append-icon="mdi-open-in-new"
              @click="openLink(item.link)"
            >
              <v-list-item-title>
                {{ $t(item.title) }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </template>
    <span>{{ $t('app.menuHelp') }}</span>
  </v-tooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'InfoLinksMenu',
  data() {
    return {
      showMenu: false,
      items: [
        {
          title: 'common.knowledgeBase',
          icon: 'mdi-school',
          link: this.$t('links.knowledgeBase').toString()
        },
        {
          title: 'administration.callbackService',
          icon: 'mdi-face-agent',
          link: this.$t('links.callbackService').toString()
        },
        {
          title: 'firmware.releaseNotes',
          icon: 'mdi-bullhorn-outline ',
          link: this.$t('links.releaseNotes').toString()
        },
        {
          title: 'common.systemStatus',
          icon: 'mdi-chart-box-outline',
          link: this.$t('links.statusPage').toString()
        }
      ]
    };
  },
  methods: {
    openLink(link: string) {
      window.open(link, '_blank');
      this.showMenu = false;
    }
  }
});
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss' as colors;
.list :deep(.v-list-item__prepend) {
  width: 35px;
}
.list :deep(.v-list-item__append) {
  color: colors.$disabled-inputs;
  width: 28px;
  font-size: 12px !important;
}
</style>
